import { createFileRoute } from '@tanstack/react-router'
import { LegalEntityForm, organizationSearchSchema } from '@/features/master-data/index.ts'

export const Route = createFileRoute('/_authenticated/master-data/legal-entities/$organizationId/edit')({
  component: EditLegalEntityPage,
  head: () => ({ meta: [{ title: '编辑经营主体 · Super Mega' }] }),
  validateSearch: organizationSearchSchema
})

function EditLegalEntityPage() {
  const { organizationId } = Route.useParams()
  return <LegalEntityForm organizationId={organizationId} returnSearch={Route.useSearch()} />
}
